import {useMemo} from 'react';

import {getAuthorityName} from '../api';

const useAuthorityName = authority => useMemo(() => authority && getAuthorityName(authority), [authority]);

export default useAuthorityName;
